module.exports = {
  archiveRoomsFeature:
    process.env.REACT_APP_PROJECT_ARCHIVE_ROOM_FEATURE === 'true'
}
